import { createRouter, createWebHistory } from './simpleRouter'

import ForgotPassword from '../components/ForgotPassword.vue';
import ResetPassword from '../components/ResetPassword.vue';
const baseKeywords = 'vampiro a máscara, ficha vampiro, rpg vampiro, clãs vampiro, disciplinas vampiro, v20, v5, ficha online vampiro'

const SeoStub = { template: '<div />' }

export const routes = [
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: ForgotPassword,
    meta: {
      view: 'forgot-password',
      title: 'Recuperar Senha | Vampiro A Máscara',
      description: 'Recupere sua senha para acessar sua conta.',
      keywords: baseKeywords,
    },
  },
  {
    path: '/reset-password/:token',
    name: 'reset-password',
    component: ResetPassword,
    meta: {
      view: 'reset-password',
      title: 'Redefinir Senha | Vampiro A Máscara',
      description: 'Redefina sua senha para acessar sua conta.',
      keywords: baseKeywords,
    },
  },
  {
    path: '/',
    name: 'home',
    component: SeoStub,
    meta: {
      view: 'home',
      title: 'Vampiro A Máscara | Ficha Online, Clãs, Disciplinas e Regras',
      description:
        'RPG de Vampiro A Máscara com fichas online, repositório de clãs, disciplinas detalhadas e regras essenciais para V20 e V5.',
      keywords: baseKeywords
    }
  },
  {
    path: '/ficha-vampiro-a-mascara',
    name: 'character-sheets',
    component: SeoStub,
    meta: {
      view: 'characterSheets',
      title: 'Ficha de Vampiro A Máscara Online | Monte personagens V20 e V5',
      description:
        'Crie e gerencie ficha de Vampiro A Máscara com seitas, clãs e disciplinas, incluindo regras de V20 e V5 para seu crônica.',
      keywords: baseKeywords
    }
  },
  {
    path: '/clas',
    name: 'all-clans',
    component: SeoStub,
    meta: {
      view: 'allClans',
      title: 'Clãs de Vampiro A Máscara | Camarilla, Sabbat e independentes',
      description:
        'Explore os clãs de Vampiro A Máscara, descubra símbolos, fraquezas e disciplinas únicas para ambientar suas mesas de RPG.',
      keywords: baseKeywords
    }
  },
  {
    path: '/clas/gangrel',
    name: 'clan-gangrel',
    component: SeoStub,
    meta: {
      view: 'allClans',
      clanId: 'gangrel',
      title: 'Clã Gangrel | Vampiro A Máscara - poderes e fraquezas',
      description:
        'Gangrel em Vampiro A Máscara: metamorfose, animalismo e fortitude com foco em sobrevivência, crônicas selvagens e fichas online.',
      keywords: baseKeywords
    }
  },
  {
    path: '/disciplinas',
    name: 'disciplines',
    component: SeoStub,
    meta: {
      view: 'disciplines',
      title: 'Disciplinas de Vampiro A Máscara | Domine os poderes vampíricos',
      description:
        'Consulta rápida das disciplinas de Vampiro A Máscara com descrições claras para montar fichas, planejar poderes e narrar crônicas.',
      keywords: baseKeywords
    }
  },
  {
    path: '/regras',
    name: 'rules',
    component: SeoStub,
    meta: {
      view: 'rules',
      title: 'Regras de Vampiro A Máscara | Ambientação e criação de personagens',
      description:
        'Principais regras de Vampiro A Máscara com foco em ambientação gótica, estrutura de crônicas e construção de personagens de RPG.',
      keywords: baseKeywords
    }
  },
  {
    path: '/livros',
    name: 'books',
    component: SeoStub,
    meta: {
      view: 'books',
      title: 'Livros de Vampiro A Máscara | Referências essenciais do RPG',
      description:
        'Catálogo de livros e suplementos de Vampiro A Máscara para narradores e jogadores que buscam aprofundar crônicas e regras.',
      keywords: baseKeywords
    }
  },
  {
    path: '/jogos',
    name: 'games',
    component: SeoStub,
    meta: {
      view: 'games',
      title: 'Jogos inspirados em Vampiro A Máscara | Experiências no Mundo das Trevas',
      description:
        'Jogos digitais e de mesa inspirados em Vampiro A Máscara para expandir experiências de RPG e vivenciar o Mundo das Trevas.',
      keywords: baseKeywords
    }
  },
  {
    path: '/loja',
    name: 'store',
    component: SeoStub,
    meta: {
      view: 'store',
      title: 'Loja de Vampiro A Máscara | Livros, dados e acessórios',
      description:
        'Produtos temáticos de Vampiro A Máscara com livros, dados, acessórios e itens para enriquecer sessões de RPG online e presenciais.',
      keywords: baseKeywords
    }
  },
  {
    path: '/seitas',
    name: 'sects',
    component: SeoStub,
    meta: {
      view: 'sectsIndex',
      title: 'Seitas de Vampiro A Máscara | Camarilla, Sabbat e Anarquistas',
      description:
        'Panorama das seitas de Vampiro A Máscara com resumos de Camarilla, Sabbat, Anarquistas e Independentes para fichas e crônicas.',
      keywords: baseKeywords
    }
  },
  {
    path: '/chat',
    name: 'chat',
    component: SeoStub,
    meta: {
      view: 'chat',
      title: 'Chat de RPG Vampiro A Máscara | Conecte sua coterie online',
      description:
        'Chat dedicado a Vampiro A Máscara para reunir jogadores, discutir clãs, disciplinas e organizar sessões no Mundo das Trevas.',
      keywords: baseKeywords
    }
  },
  {
    path: '/cronicas',
    name: 'chronicles-list',
    component: SeoStub,
    meta: {
      view: 'chroniclesList',
      title: 'CrÇïnicas da Comunidade | Vampiro A MÇ­scara',
      description:
        'Explore crÇïnicas criadas pela comunidade de Vampiro A MÇ­scara e encontre inspiraÇõÇæes para suas mesas.',
      keywords: baseKeywords
    }
  },
  {
    path: '/cronicas/criar',
    name: 'chronicle-create',
    component: SeoStub,
    meta: {
      view: 'chronicleCreate',
      title: 'Criar CrÇ­nica | Vampiro A MÇ­scara',
      description:
        'Publique sua crÇ­nica de Vampiro A MÇ­scara com sinopse, tags e capÇ­tulos para a comunidade.',
      keywords: baseKeywords
    }
  },
  {
    path: '/cronicas/:id/editar',
    name: 'chronicle-edit',
    component: SeoStub,
    meta: {
      view: 'chronicleEdit',
      title: 'Editar CrÇ­nica | Vampiro A MÇ­scara',
      description:
        'Atualize detalhes da sua crÇ­nica, incluindo capa, sinopse e capÇ­tulos para os leitores.',
      keywords: baseKeywords
    }
  },
  {
    path: '/cronicas/:id',
    name: 'chronicle-detail',
    component: SeoStub,
    meta: {
      view: 'chronicleDetail',
      title: 'Detalhes da CrÇ­nica | Vampiro A MÇ­scara',
      description:
        'Leia crÇïnicas completas da comunidade de Vampiro A MÇ­scara, com capÇ­tulos e informaÇõÇæes do autor.',
      keywords: baseKeywords
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: SeoStub,
    redirect: '/',
    meta: {
      view: 'home'
    }
  }
]

export default createRouter({
  history: createWebHistory(),
  routes
})
